"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductsListView = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const ramda_1 = require("ramda");
const react_redux_1 = require("react-redux");
const hooks_1 = require("./hooks");
const use_products_list_context_menu_1 = require("./hooks/use-products-list-context-menu");
const products_customize_view_1 = require("./products-customize-view");
// TODO: probably issue with cycle dependency, need to check
const products_parser_1 = require("./utils/products.parser");
const client_constants_1 = require("../../../../client/client.constants");
const hooks_2 = require("../../../../client/hooks");
const product_table_1 = require("../../../../common/product-table");
const table_filter_1 = require("../../../../common/table-filter");
const table_sort_1 = require("../../../../common/table-sort");
const use_table_loading_state_1 = require("../../../../common/use-table-loading-state");
const context_1 = require("../../../../context");
const hooks_3 = require("../../../../hooks");
const products_table_1 = require("../../../../store/catalogs/products-table");
const feature_flags_1 = require("../../../../../feature-flags");
const hooks_4 = require("../../../../../hooks");
const localization_1 = require("../../../../../localization");
const store_1 = require("../../../../../store");
const ProductsListView = ({ selectionModel, setSelectionModel, onContextMenuEdit, isAtLeastOneProductSelected, selectProduct, products, paginationModel, totalCount, onPaginationModelChange, areProductsLoading = true, arePageRowsIncomplete = false, isPageRowsSyncing = false, chunkLoadErrorProductCount = 0, canRetryChunkLoad = false, retryChunkLoad, productsLoadingError, lastVariables, isCustomizeViewOpen, onActiveProductIdChange, onCustomizeViewClose, }) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const { addSuccess } = (0, hooks_4.useNotification)();
    const { featureFlagsService } = (0, hooks_4.useFeatureFlagsService)();
    const enableMultiFiltering = featureFlagsService.isFeatureEnabled(feature_flags_1.FeatureFlag.MultiFiltering);
    const { isNodeReEnriching } = (0, context_1.useCatalogActivityProgressContext)();
    const selectedProductTreeNode = (0, hooks_3.useSelectedTreeNode)();
    const selectedCatalogId = (0, store_1.useSelectedCatalogId)();
    const productTreeNodeId = (0, store_1.useSelectedTreeNodeId)();
    const selectedTreeNodePath = (0, store_1.useSelectedTreeNodePath)();
    const tableFilter = (0, products_table_1.useProductsTableFilter)();
    const tableSearch = (0, products_table_1.useProductsTableSearch)();
    const columnWidths = (0, products_table_1.useProductsTableColumnWidth)();
    const { pinnedColumns } = (0, products_table_1.useProductsTableDynamicColumns)();
    // Note: Default value removed to prevent sort state persistence issues when clearing sort
    const tableSort = (0, products_table_1.useProductsTableSort)();
    const tableRowSize = (0, products_table_1.useProductsTableRowSize)();
    const { refetchProductList } = (0, hooks_2.useRefetchQueries)();
    const refreshProductList = (0, react_1.useCallback)(() => refetchProductList(productTreeNodeId), [productTreeNodeId, refetchProductList]);
    const { processRowUpdate, isCellLoading, isCellSynced, isCellFailed, processRowUpdateError, } = (0, hooks_1.useProcessRowUpdate)({
        failedCellResetKey: products,
        tableFilter,
        tableSort,
        refetchProductList: refreshProductList,
        selectedTreeNodePath,
    });
    const { onCellSubmit, onCellEditStart: onSubmittedCellEditStart, isCellAutoOpen } = (0, product_table_1.useSubmittedCells)();
    const isCurrentNodeReEnriching = (0, react_1.useMemo)(() => isNodeReEnriching(productTreeNodeId), [isNodeReEnriching, productTreeNodeId]);
    const isRowDisabled = (0, react_1.useCallback)((row) => isCurrentNodeReEnriching || Boolean(row.isLocked), [isCurrentNodeReEnriching]);
    const { tableColumns: { columns, isLoading: areColumnsLoading = true, selection: { excludedColumns, selectAllMode, filterOptions, }, order: { columnsOrder, }, actions: { onChangeColumns, setOrder, }, isCellEditable, }, } = (0, hooks_1.useProductsTableConfig)({
        onActiveProductIdChange,
        isCellLoading,
        isCellSynced,
        isCellFailed,
        isRowDisabled,
        isCellAutoOpen,
        onCellSubmit,
    });
    const onPinnedColumnsChange = (0, react_1.useCallback)((next) => {
        onChangeColumns({ pinnedColumns: next });
    }, [onChangeColumns]);
    const filterableFields = (0, react_1.useMemo)(() => new Set(columns
        .filter((column) => column.filterable !== false)
        .map((column) => String(column.field))), [columns]);
    const sortableFields = (0, react_1.useMemo)(() => new Set(columns
        .filter((column) => column.sortable !== false)
        .map((column) => String(column.field))), [columns]);
    const compatibleTableFilter = (0, react_1.useMemo)(() => {
        if (areColumnsLoading || tableFilter.items.length === 0) {
            return tableFilter;
        }
        const compatibleItems = tableFilter.items
            .filter(({ field }) => filterableFields.has(field));
        if (compatibleItems.length === tableFilter.items.length) {
            return tableFilter;
        }
        return Object.assign(Object.assign({}, tableFilter), { items: compatibleItems });
    }, [areColumnsLoading, filterableFields, tableFilter]);
    (0, react_1.useEffect)(() => {
        if (areColumnsLoading || compatibleTableFilter === tableFilter) {
            return;
        }
        const removedCount = tableFilter.items.length - compatibleTableFilter.items.length;
        dispatch((0, products_table_1.setProductsTableFilter)(selectedCatalogId, compatibleTableFilter));
        if (removedCount > 0) {
            addSuccess(t({ key: 'PRODUCTS_FILTER_INCOMPATIBLE_REMOVED_NOTICE' }));
        }
    }, [
        addSuccess,
        areColumnsLoading,
        compatibleTableFilter,
        dispatch,
        selectedCatalogId,
        tableFilter,
        t,
    ]);
    const columnFieldsKey = JSON.stringify(columns.map(({ field }) => field));
    const { originalAttributeColumnIds, strategyAttributeLabels, } = (0, react_1.useMemo)(() => {
        const columnFields = JSON.parse(columnFieldsKey);
        return {
            originalAttributeColumnIds: (0, products_parser_1.getOriginalAttributeColumnIdsFromFields)(columnFields),
            strategyAttributeLabels: (0, products_parser_1.getStrategyAttributeLabelsFromFields)(columnFields),
        };
    }, [columnFieldsKey]);
    const compatibleTableSort = (0, react_1.useMemo)(() => {
        if (areColumnsLoading || !tableSort) {
            return tableSort;
        }
        const [sortItem] = (0, table_sort_1.parseDataGridSortState)(tableSort);
        if (!(sortItem === null || sortItem === void 0 ? void 0 : sortItem.field) || sortableFields.has(sortItem.field)) {
            return tableSort;
        }
        return products_table_1.defaultProductsTableState.sort;
    }, [areColumnsLoading, sortableFields, tableSort]);
    (0, react_1.useEffect)(() => {
        if (areColumnsLoading || (0, ramda_1.equals)(compatibleTableSort, tableSort)) {
            return;
        }
        dispatch((0, products_table_1.setProductsTableSort)(selectedCatalogId, compatibleTableSort));
    }, [areColumnsLoading, compatibleTableSort, dispatch, selectedCatalogId, tableSort]);
    const sortColumn = (0, react_1.useMemo)(() => (compatibleTableSort ? { key: compatibleTableSort.key, direction: compatibleTableSort.direction } : undefined), [compatibleTableSort]);
    const parsedProducts = (0, react_1.useMemo)(() => ((0, products_parser_1.convertProductToDataGridRow)(products, originalAttributeColumnIds, strategyAttributeLabels, sortColumn, !!(selectedProductTreeNode === null || selectedProductTreeNode === void 0 ? void 0 : selectedProductTreeNode.isTerminalNode))), [
        originalAttributeColumnIds,
        products,
        selectedProductTreeNode === null || selectedProductTreeNode === void 0 ? void 0 : selectedProductTreeNode.isTerminalNode,
        sortColumn,
        strategyAttributeLabels,
    ]);
    const dataGridLoadingState = (0, use_table_loading_state_1.useTableLoadingState)({
        requestVariables: lastVariables,
        isLoading: areProductsLoading || areColumnsLoading,
        hasError: Boolean(productsLoadingError),
    });
    const { displayedRows, handleCellEditStart, handleCellEditStop, stabilizedProcessRowUpdate, } = (0, product_table_1.useStableRowsDuringEdit)({
        rows: parsedProducts,
        processRowUpdate,
        onCellEditStart: onSubmittedCellEditStart,
        shouldHoldDisplayedRows: dataGridLoadingState.loading,
    });
    // Filtering
    const handleUpdateFilter = (0, react_1.useCallback)((model) => {
        var _a, _b;
        if (areColumnsLoading)
            return;
        const nextTableFilter = (0, table_filter_1.buildFilterStateFromUIDataGridFilter)(model);
        const nextTableSearch = (_b = (_a = model.quickFilterValues) === null || _a === void 0 ? void 0 : _a.join(' ')) !== null && _b !== void 0 ? _b : '';
        if (!(0, ramda_1.equals)(nextTableFilter, compatibleTableFilter)) {
            dispatch((0, products_table_1.setProductsTableFilter)(selectedCatalogId, nextTableFilter));
        }
        if (nextTableSearch !== tableSearch) {
            dispatch((0, products_table_1.setProductsTableSearch)(selectedCatalogId, nextTableSearch));
        }
    }, [areColumnsLoading, dispatch, selectedCatalogId, compatibleTableFilter, tableSearch]);
    const persistedFilterData = (0, react_1.useMemo)(() => ({
        filter: !areColumnsLoading
            ? (0, table_filter_1.parseTableFilterStateToDataGridFilter)(compatibleTableFilter, tableSearch)
            : { quickFilterValues: [], items: [] },
    }), [compatibleTableFilter, tableSearch, areColumnsLoading]);
    const { filterModel, setFilterModel, } = (0, ui_components_1.useFilter)({
        persistedState: persistedFilterData.filter,
        setPersistedState: handleUpdateFilter,
    });
    const persistedSortData = (0, react_1.useMemo)(() => ({
        sort: !areColumnsLoading ? (0, table_sort_1.parseDataGridSortState)(compatibleTableSort) : [],
    }), [areColumnsLoading, compatibleTableSort]);
    // Sorting
    const handleUpdateSort = (0, react_1.useCallback)((model) => {
        if (areColumnsLoading)
            return;
        const newTableSort = (0, table_sort_1.buildSortStateFromUIDataGridSort)(model);
        if (!(0, ramda_1.equals)(newTableSort, tableSort)) {
            dispatch((0, products_table_1.setProductsTableSort)(selectedCatalogId, newTableSort));
        }
    }, [compatibleTableSort, dispatch, selectedCatalogId, areColumnsLoading]);
    const { sortModel, setSortModel, } = (0, ui_components_1.useSorting)({
        persistedState: persistedSortData.sort,
        setPersistedState: handleUpdateSort,
    });
    const productTerminalNodeMap = (0, react_1.useMemo)(() => {
        const map = new Map();
        products === null || products === void 0 ? void 0 : products.forEach((p) => {
            const nodeId = p === null || p === void 0 ? void 0 : p.productTreeNodeId;
            if (nodeId)
                map.set(p.id, nodeId);
        });
        return Object.fromEntries(map);
    }, [products]);
    const { ContextMenu, handleContextMenu, } = (0, use_products_list_context_menu_1.useProductsListContextMenu)({
        onEdit: onContextMenuEdit,
        selectProduct,
        hasSelection: isAtLeastOneProductSelected,
        productTerminalNodeMap,
    });
    const { columns: mergedColumns, onColumnResize } = (0, ui_components_1.useColumnWidth)({
        columns,
        persistedState: columnWidths,
        setPersistedState: (next) => {
            dispatch((0, products_table_1.setProductsTableColumnWidth)(selectedCatalogId, next));
        },
    });
    const pageRowsLoadStatus = (0, react_1.useMemo)(() => ({
        isSyncing: isPageRowsSyncing,
        failedProductCount: chunkLoadErrorProductCount,
        canRetry: canRetryChunkLoad,
        onRetry: retryChunkLoad,
    }), [
        canRetryChunkLoad,
        chunkLoadErrorProductCount,
        isPageRowsSyncing,
        retryChunkLoad,
    ]);
    return (react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(product_table_1.ProductTable, { key: productTreeNodeId !== null && productTreeNodeId !== void 0 ? productTreeNodeId : 'products-table', columns: mergedColumns, onColumnResize: onColumnResize, pinnedColumns: pinnedColumns, onPinnedColumnsChange: onPinnedColumnsChange, rows: displayedRows, loading: dataGridLoadingState.loading, error: productsLoadingError === null || productsLoadingError === void 0 ? void 0 : productsLoadingError.message, pageRowsLoadStatus: pageRowsLoadStatus, slotProps: {
            loadingOverlay: {
                variant: 'linear-progress',
                noRowsVariant: 'skeleton',
            },
        }, rowCount: totalCount, filterModel: filterModel, onFilterModelChange: setFilterModel, sortModel: sortModel, onSortModelChange: setSortModel, paginationModel: paginationModel, onPaginationModelChange: onPaginationModelChange, rowSelectionModel: selectionModel, onRowSelectionModelChange: setSelectionModel, isHeaderSelectionDisabled: arePageRowsIncomplete, pageSizeOptions: client_constants_1.PAGE_SIZES, onContextMenu: handleContextMenu, onEditAttribute: onContextMenuEdit, hasSelection: isAtLeastOneProductSelected, processRowUpdate: stabilizedProcessRowUpdate, onProcessRowUpdateError: processRowUpdateError, onCellEditStart: handleCellEditStart, onCellEditStop: handleCellEditStop, tableRowSize: tableRowSize, isCellEditable: isCellEditable, isRowDisabled: isRowDisabled, enableMultiFiltering: enableMultiFiltering, columnsOrder: columnsOrder, onColumnOrderChange: setOrder }), react_1.default.createElement(ContextMenu, null), isCustomizeViewOpen && (react_1.default.createElement(products_customize_view_1.ProductCustomizeViewContainer, { productTreeNodeId: productTreeNodeId, excludedColumns: excludedColumns, columnsOrder: columnsOrder, selectAllMode: selectAllMode, filterOptions: filterOptions, onChangeColumns: onChangeColumns, onClose: onCustomizeViewClose }))));
};
exports.ProductsListView = ProductsListView;
exports.default = exports.ProductsListView;
